import styled from 'styled-components'

export const IndexBoxStyle = styled.div`
    height: 280px;
    width: 280px;
    background-color: black;
    transform: translate(0px, 60vh);
`